import { GetOcrTradesHistoryApi } from "@/features/accounts/ocr/services/get-trades-history-api";
import { GetOcrTradesHistoryRequestModel } from "@/features/accounts/ocr/services/get-trades-history-model";

/// OCR取込履歴取得処理
export class GetOcrTradesHistoryService {
    private getOcrTradesHistoryApi = new GetOcrTradesHistoryApi();

    /**
     * OCR取込履歴取得API実行
     */
    public async getOcrTradesHistory(param: GetOcrTradesHistoryRequestModel) {
        return await this.getOcrTradesHistoryApi.getOcrTradesHistory(param);
    }
}
